export default "__VITE_ASSET__uVACLALF__"